module.exports = __webpack_public_path__ + "images/referenzen/socialmedia/edeka_rezeptvideo_mit_julia_spargel_quiche.jpg";